import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AppContext } from '../../../App.context';

export default function PrivateRoute({ children }) {
  const { appState } = useContext(AppContext);

  if (!appState.accessToken) {
    return <Navigate to="/login" />;
  }

  return children;
}
